
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M11.599 10.5a14.7 14.7 0 0 0 .123-2.57M11.6 10.5c-.398 2.892-1.635 5-3.099 5m3.099-5h3.611m-3.611 0H9.153m-.653 5c-.894 0-1.704-.787-2.29-2.058M8.5 15.5a7 7 0 0 0 6.098-10.44M8.5 15.5a6.97 6.97 0 0 1-3.434-.899M5.401 6.5a15 15 0 0 0-.127 2.446M5.4 6.5c.398-2.891 1.635-5 3.099-5m-3.099 5H7.72m-2.318 0H1.79m6.71-5c.874 0 1.667.75 2.249 1.97M8.5 1.5a7 7 0 0 0-6.135 10.373M8.5 1.5c1.22 0 2.366.312 3.365.86M3.719 10.5H1.79m13.421-4h-2.057M1.5 15.5l14-14"}})])
          )
        }
      }
    